import React from 'react';
import BeneficiryBase from '../../components/beneficiary/BeneficiaryBase';
import SideBar from '../../components/sidebar/Sidebar';
import TrusteeBase from '../../components/trustee/TrusteeBase';
import UserBase from '../../components/user/UserBase';
import { getUser } from '../../services/user-service';
import Writingcenter from './Writing-center';
import OrganizationBase from "../organization/OrganizationBase";


function Writingroute() {
    let role = getUser().role;
    if (role === "BENEFICIARY") {
         return (
            <BeneficiryBase>
                <div className="mt-5">
                </div>
                <SideBar>
                    <Writingcenter />
                </SideBar>
            </BeneficiryBase>
        )
    }
//     else if (role === "USER") {
//     else if (role === "USER" || (role === "ORG_USER" && getUser().accountType === "primary")) {
    else if (
        role === "USER" ||
        (role === "ORG_USER" && (getUser().accountType === "primary" || getUser().accountType === "secondary"))
    ) {
        return (
            <UserBase>
                <div className="mt-5">
                </div>
                <SideBar>
                    <Writingcenter/>
                </SideBar>
            </UserBase>
        )
    }
    else if (role === "TRUSTEE") {
        return (
            <TrusteeBase>
                <div className="mt-5">
                </div>
                <SideBar>
                    <Writingcenter />
                </SideBar>
            </TrusteeBase>
        )
    }
    else if (role === "TENANT_ADMIN" || role === "TENANT_USER") {
        return (
      <OrganizationBase>
                <div className="mt-5"></div>
                <SideBar>
                    <Writingcenter />
                </SideBar>
      </OrganizationBase>
        );
    }


}
export default Writingroute;